module.exports = __webpack_public_path__ + "img/logo_kp.cca74825.webp";